import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { pathPickMembershipQueryApi } from "@/features/pathpick/features/membership/api/query";
import { PathPickMembershipPlansResponse } from "@/features/pathpick/features/membership/types/response";
import useCompanyIdentity from "@/shared/hooks/useCompanyIdentity";
import { toCamelKeyObject } from "@/utils/case";

// 활성 멤버십 플랜 목록 조회.
// 화면의 플랜은 문자열 id("basic"/"pro")로 하드코딩돼 있는데 신청 API는 정수 plan_id를 받는다 —
// 이 훅이 code로 서버 id를 찾아주는 통로다.
const useGetPathPickMembershipPlans = () => {
  const { companyId } = useCompanyIdentity();

  const { data, isPending } = useQuery({
    queryKey: ["pathpick", "membership-plans", companyId],
    queryFn: async () => {
      const data = await pathPickMembershipQueryApi.getPathPickMembershipPlans(
        companyId as number
      );
      return toCamelKeyObject(data) as PathPickMembershipPlansResponse;
    },
    enabled: Boolean(companyId),
  });

  const plans = data?.plans;

  // 서버 code의 대소문자 표기가 바뀌어도 매칭이 깨지지 않게 대소문자를 무시한다.
  const findPlanIdByCode = useCallback(
    (code: string) =>
      plans?.find((plan) => plan.code?.toUpperCase() === code.toUpperCase())
        ?.id ?? undefined,
    [plans]
  );

  return { plans, isPending, findPlanIdByCode };
};

export default useGetPathPickMembershipPlans;
